<mat-toolbar color="primary" class="header">
    <div class="left-section">
        @if (isStandaloneMode) {
            <a [href]="appUrl" rel="noopener noreferrer">
                <img [src]="logo" alt="App Logo" class="app-logo" />
            </a>
        } @else {
            <img [src]="logo" alt="App Logo" class="app-logo" />
        }
        @if (showPoweredBy) {
            <span class="powered-by">Powered by Perse&trade;</span>
        }
    </div>
    <div class="center-section d-none d-sm-block">
        <!-- @if (isUserLoggedIn$ | async) { -->
            <span class="app-title">{{ name }}</span>
        <!-- } -->
    </div>
    @if (isStandaloneMode) {
    <div class="right-section">
        @if (isUserLoggedIn$ | async) {
            <span class="user-name d-none d-lg-block">{{ userName }}</span>
            
            <!-- Notification Button -->
            <button mat-icon-button [matMenuTriggerFor]="notificationMenu" class="notification-button">
                <mat-icon [matBadge]="unreadNotificationCount$ | async" 
                          [matBadgeHidden]="(unreadNotificationCount$ | async) === 0"
                          matBadgeColor="warn">
                    notifications
                </mat-icon>
            </button>
            <mat-menu #notificationMenu="matMenu" class="notification-menu">
                <div class="menu-header" mat-menu-item disabled>
                    <!-- <mat-icon>notifications</mat-icon> -->
                    <span>Notifications</span>
                    <!-- <button mat-icon-button (click)="onRefreshNotifications(); $event.stopPropagation();" class="refresh-btn">
                        <mat-icon>refresh</mat-icon>
                    </button> -->
                </div>
                <mat-divider class="divider-without-margin"></mat-divider>
                
                @for (notification of notifications$ | async; track notification.id) {
                    <button mat-menu-item 
                            (click)="onNotificationClick(notification)"
                            [class.unread]="!notification.isRead"
                            class="notification-item">
                        <div class="notification-content">
                            <span class="notification-text">{{ notification.text }}</span>
                            @if (!notification.isRead) {
                                <mat-icon class="unread-indicator">fiber_manual_record</mat-icon>
                            }
                        </div>
                    </button>
                    <mat-divider class="divider-without-margin"></mat-divider>
                } @empty {
                    <div mat-menu-item disabled class="no-notifications">
                        <mat-icon>notifications_none</mat-icon>
                        <span>No notifications</span>
                    </div>
                }
                
                @if ((notifications$ | async)?.length && (notifications$ | async)!.length > 0) {
                    <div class="menu-actions">
                        <button mat-menu-item (click)="onMarkAllNotificationsRead()">
                            <mat-icon>done_all</mat-icon>
                            <span>Mark all as read</span>
                        </button>
                        <button mat-menu-item (click)="onClearAllNotifications()">
                            <mat-icon>clear_all</mat-icon>
                            <span>Clear all</span>
                        </button>
                    </div>
                }
            </mat-menu>

            <!-- User Account Button -->
            <button mat-icon-button [matMenuTriggerFor]="userMenu" class="user-menu-button">
                <mat-icon>account_circle</mat-icon>
            </button>
            <mat-menu #userMenu="matMenu">
                <div class="menu-header" mat-menu-item disabled>
                    <mat-icon>person</mat-icon>
                    <span>{{ userName }}</span>
                </div>
                <mat-divider></mat-divider>
                <button mat-menu-item routerLink="/profile">
                    <mat-icon>manage_accounts</mat-icon>
                    <span>Profile</span>
                </button>
                <button mat-menu-item (click)="onLogout()">
                    <mat-icon>logout</mat-icon>
                    <span>Logout</span>
                </button>
            </mat-menu>
        }
    </div>
    }
</mat-toolbar>